---
title: "Dynamic Test Model Manufacturing Readiness Review Complete"
date: 2024-11-11
category: "Engineering"
---

We've completed the Manufacturing Readiness Review (MRR) for our dynamic test model, marking a key milestone in our telescope development program.

![Mass simulator rendering](/images/blog-mass-simulator-mrr/mass-simulator-rendering.png)
![Mass simulator rendering 2](/images/blog-mass-simulator-mrr/mass-simulator-rendering-2.png)



## What is a Dynamic Test Model (DTM)?

A DTM/mass simulator is a purpose-built test article that replicates the mass properties and structural characteristics of flight hardware without the complexity and cost of building the actual system. It's a critical tool for validating manufacturing and assembly processes before committing to flight units.

## Why Build One?

Our mass simulator serves two primary purposes:

**Proving Assembly Processes** — Before assembling flight hardware, we need confidence that our procedures work. The mass simulator lets us rehearse integration sequences, verify tooling, and train technicians on handling procedures. Any issues discovered here are far cheaper to fix than problems found during flight unit assembly.

**Vibration Testing and Model Validation** — We selected materials specifically to match the dynamic behavior of flight hardware. This gives us realistic vibration modes during testing, allowing us to validate our structural models against physical data. Accurate models are essential for predicting how the telescope will respond to launch loads.

## What's Next

With the MRR complete, we move into fabrication. The mass simulator will go through the full integration flow, followed by vibration testing to correlate our finite element models. Lessons learned will feed directly into flight hardware production.
